import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import config from '../config';

export function useAuth() {
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => {
        return !!localStorage.getItem('accessToken') || !!sessionStorage.getItem('accessToken');
    });

    useEffect(() => {
        // Optional: You could add token validation logic here in future
    }, []);

    const login = () => {
        setIsAuthenticated(true);
    };

    const logout = async () => {
        const refreshToken = localStorage.getItem('refreshToken') || sessionStorage.getItem('refreshToken');

        try {
            if (refreshToken) {
                await axios.post(`${config.BASE_URL}/auth/logout`, { refreshToken });
            }
        } catch (error) {
            console.error('Logout request failed:', error);
        }

        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        sessionStorage.removeItem('accessToken');
        sessionStorage.removeItem('refreshToken');
        setIsAuthenticated(false);
        navigate('/login');
    };

    return {
        isAuthenticated,
        login,
        logout,
    };
}
